import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    getSegmentTags,
    getSegmentMLTags,
    getSegmentTagsLoading,
    getSegmentTagsState,
} from '../selectors';
import { getUserPermissionsKeys } from '../../auth/selectors';
import { PropTypes } from 'prop-types';
import { segmentTagsRequested } from '../actions';
import TopTagsCard from '../../../common/TopTagsCard';
import { TAXONOMY_DROPDOWN as DROPDOWN } from '../../../common/constants';
import { noop } from '../../../common/propTypes';

function SegmentTags({
    segmentId,
    onSelect,
    tags,
    mlTags,
    loading,
    permissions,
    tagsState,
}) {
    const [taxonomy, setTaxonomy] = useState(DROPDOWN[0].key);

    useEffect(() => {
        // sets inital taxonomy and segmentId in state to fetch tags for on component load
        if (!tagsState[segmentId]) {
            onSelect(taxonomy, segmentId);
        }
    }, []);

    const mainContent = (
        <TopTagsCard
            id={segmentId}
            heading={' '}
            taxonomy={taxonomy}
            onTaxonomySelect={(evt) => {
                onSelect(evt, segmentId);
                setTaxonomy(evt);
            }}
            topTags={tags}
            mlTags={mlTags}
            tagsLoading={loading}
            showTotal={false}
            loading={loading}
            permissions={permissions}
        />
    );

    return mainContent;
}

SegmentTags.propTypes = {
    segmentId: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    tags: PropTypes.arrayOf(PropTypes.object),
    mlTags: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    permissions: PropTypes.arrayOf(PropTypes.string),
    tagsState: PropTypes.object,
};

SegmentTags.defaultProps = {
    segmentId: null,
    tags: [],
    mlTags: [],
    loading: false,
    onSelect: noop,
    permissions: [],
};

const mapStateToProps = (state) => {
    return {
        tags: getSegmentTags(state),
        mlTags: getSegmentMLTags(state),
        loading: getSegmentTagsLoading(state),
        permissions: getUserPermissionsKeys(state),
        tagsState: getSegmentTagsState(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSelect: (taxonomy, segmentId) =>
            dispatch(segmentTagsRequested(taxonomy, segmentId)),
    };
};

const ConnectedTopTags = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SegmentTags);

export default ConnectedTopTags;
